import Input from 'semantic-ui-react/dist/commonjs/elements/Input';
import '@purple/semantic-ui-family-connection-theme/components/input.css';

export default Input;
